/**
 * Celeste Dice Factory
 *
 * Creates color-specific celeste dice components using a factory pattern.
 * All 4 color variants (Red, Blue, Yellow, Green) are generated from
 * CelesteDiceComponent with per-color schemes.
 */

import React from 'react';
import type { DiceProps } from '../basics/constants/types';
import CelesteDiceComponent from './CelesteDiceComponent';
import {
  CELESTE_DICE_COLOR_SCHEMES,
  type CelesteDiceColorScheme
} from './constants/diceColorSchemes';

type DiceColor = 'red' | 'blue' | 'yellow' | 'green';

function createCelesteDice(color: DiceColor) {
  const colorScheme: CelesteDiceColorScheme = CELESTE_DICE_COLOR_SCHEMES[color];
  const displayName = `Celeste${color.charAt(0).toUpperCase() + color.slice(1)}Dice`;

  const ColoredDice = React.memo(function ColoredDice(props: DiceProps) {
    return <CelesteDiceComponent {...props} colorScheme={colorScheme} />;
  });

  ColoredDice.displayName = displayName;
  return ColoredDice;
}

export const RedDice = createCelesteDice('red');
export const BlueDice = createCelesteDice('blue');
export const YellowDice = createCelesteDice('yellow');
export const GreenDice = createCelesteDice('green');
